import axios from './axiosInstance';

/**
 * ════════════════════════════════════════════════════════════════════════════════
 *  모바일 웹 -> 비토리지 앱 실행 / 스토어 이동
 * ════════════════════════════════════════════════════════════════════════════════
 *  MLoginPg.js 의 handleAppLaunch() 및 연관 상태값/상수를 그대로 옮겨 공통화한 모듈.
 *  (UserHome.js 의 Android/iOS 앱설치 버튼과 MLoginPg 가 동일 동작을 공유하기 위함)
 * ════════════════════════════════════════════════════════════════════════════════
 */

const ua = typeof navigator !== 'undefined' ? navigator.userAgent : '';
export const isIOSDevice = () =>
    /iPhone|iPad|iPod/.test(ua) || (ua.includes('Macintosh') && typeof document !== 'undefined' && 'ontouchend' in document);
export const isAndroidDevice = () => !isIOSDevice() && /Android/i.test(ua);

const ANDROID_SCHEME = 'intent://MainPg#Intent;scheme=btorage;package=com.toelmobile;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.toelmobile;end';
const IOS_DEEP_LINK = 'btorage://MainPg';
const IOS_STORE_URL = 'https://apps.apple.com/app/id6738265560';

const mobileConsoleLog = async (label, data) => {
    const message = `${label}${typeof data === 'undefined' ? '' : (typeof data === 'object' ? ' ' + JSON.stringify(data) : ' ' + data)}`;
    try {
        await axios.post('/log', {message});
    } catch (error) {
        console.log('❌ 서버 로그 전송 실패:', error);
    }
};

/** 기기환경(Android / iOS)에 따라 앱 실행 또는 스토어 설치페이지로 이동 */
export const launchBtorageApp = () => {
    const clickId = localStorage.getItem('bt_sub1');
    const adChannel = localStorage.getItem('bt_sub2');
    const branchUrl = `https://vu6b8.app.link/btorage_${adChannel}_ads?bt_sub1=${clickId}&bt_sub2=${adChannel}`;

    if (clickId && adChannel) {
        console.log("Btorage Branch Url : ", branchUrl);
        mobileConsoleLog("Btorage Branch Url : ", branchUrl);
        const a = document.createElement('a');
        a.href = branchUrl;
        a.style.display = 'none';
        a.setAttribute('rel', 'noopener');
        document.body.appendChild(a);
        a.click();

    } else if (isIOSDevice()) {
        console.log("iOS 일반 딥링크실행");
        // 포그라운드
        let didHide = false;

        const handleVisibilityChange = () => {
            if (document.hidden) {
                // 백그라운드
                didHide = true;
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        const a = document.createElement('a');
        a.href = IOS_DEEP_LINK;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();

        // 6초 뒤에도 웹이 포그라운드(앱실행X)면 애플스토어 이동
        setTimeout(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (!didHide) {
                window.location.href = IOS_STORE_URL;
            }
        }, 6000);

    } else if (isAndroidDevice()) {
        console.log("Android 일반 딥링크실행");
        window.location.href = ANDROID_SCHEME;
    }
};
